import cx from 'classnames';
import ChevronIcon from 'icons/ChevronIcon';
import { MenuButton } from 'components/shared/Menu';
import { forwardRef } from 'react';

type MenuFilterProps = {
  menuLabel: string | React.ReactNode;
  isExpanded: boolean;
  hasSelectedItem?: boolean;
};

const FilterMenuButton = forwardRef<HTMLButtonElement, MenuFilterProps>(
  ({ isExpanded, hasSelectedItem = false, menuLabel }, ref) => {
    const chevronClasses = cx('ml-1 h-3 w-3 rotate-0', {
      'rotate-180 pb-05': isExpanded,
      'pt-px': !isExpanded
    });

    const menuButtonClasses = cx('flex items-center transition duration-200', {
      'hover:text-gray-500': !hasSelectedItem,
      'text-blue-500 hover:text-blue-900': hasSelectedItem
    });

    return (
      <MenuButton className={menuButtonClasses} ref={ref}>
        <div>{menuLabel}</div>
        <ChevronIcon variant="small" className={chevronClasses} aria-hidden />
      </MenuButton>
    );
  }
);

FilterMenuButton.displayName = 'FilterMenuButton';

export default FilterMenuButton;
